import { defineStore } from "pinia";
import { ref } from "vue";

export const useDecisionPositionsGridStore = defineStore('decisionPositionsGridStore', () => {
    const hideActions = ref(false);
    const showConfirmModal = ref(false);
    const showNds = ref(true);
    const summarizeTotalPrices = ref([
        { name: 'Итоговая сумма: {_1} $', field: 'price' },
    ]);

    function setHideActions(value) {
        hideActions.value = value;
    }

    function setShowConfirmModal(value) {
        showConfirmModal.value = value;
    }

    function setShowNds(value) {
        showNds.value = value;
    }

    function addSummarizeTotalPrice(name, field) {
        summarizeTotalPrices.value.push({ name, field });
    }

    return {
        hideActions,
        setHideActions,
        showNds,
        showConfirmModal,
        setShowConfirmModal,
        setShowNds,
        summarizeTotalPrices,
        addSummarizeTotalPrice,
    }
});
